import { config, handleResponse } from '../../_helpers';

export const truckingRateServices = {
    getAllTruckingRates,
    getTruckingRates,
    createTruckingRate,
    updateTruckingRate,
    getTruckingRateById,
    deleteTruckingRates,
    activation,
    searchTruckingRates,
    getTruckingRateListByCode,
    truckingGroupByChargeCode,
    truckingReadGroupCharge,
    truckingReadGroupBranchCharge,
};
function getAllTruckingRates() {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}/TruckingRates`, requestOptions).then(handleResponse);
}
function getTruckingRates(skip, take, search, filter) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        return fetch(`${config.apiUrl}/TruckingRates/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/TruckingRates/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}

function createTruckingRate(truckingRate, userProfile) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({
            dateEffective: truckingRate.dateEffective,
            chargeCode: truckingRate.chargeCode,
            areaCode: truckingRate.areaCode,
            portCode: truckingRate.portCode,
            branchCode: truckingRate.branchCode,
            stdRateWvat: truckingRate.stdRateWvat,
            backloadRateWvat: truckingRate.backloadRateWvat,
            stdRateTandemRates: truckingRate.stdRateTandemRates,
            userCreated: userProfile.userId
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/TruckingRates`, requestOptions).then(handleResponse);
}
function updateTruckingRate(truckingRate, userProfile) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify({
            dateEffective: truckingRate.dateEffective,
            chargeCode: truckingRate.chargeCode,
            areaCode: truckingRate.areaCode,
            portCode: truckingRate.portCode,
            branchCode: truckingRate.branchCode,
            stdRateWvat: truckingRate.stdRateWvat,
            backloadRateWvat: truckingRate.backloadRateWvat,
            stdRateTandemRates: truckingRate.stdRateTandemRates,
            userModified: userProfile.userId
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/TruckingRates/update/${truckingRate.id}`, requestOptions).then(handleResponse);
}
function getTruckingRateById(id) {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}/TruckingRates/get/${id}`, requestOptions).then(handleResponse);
}
function deleteTruckingRates(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/TruckingRates/delete`, requestOptions).then(handleResponse);
}
function activation(id, isActive) {
    const requestOptions = {
        method: 'PUT'
    };

    return fetch(`${config.apiUrl}/TruckingRates/activate/${id}?isActive=${isActive}`, requestOptions).then(handleResponse);
}
function searchTruckingRates(take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };

    return fetch(`${config.apiUrl}/TruckingRates/load?filter=${filter}&search=${search}&take=${take}`, requestOptions).then(handleResponse);
}
function getTruckingRateListByCode(charge, branch, area) {
    const requestOptions = {
        method: 'GET'
    };
    if (area) {
        return fetch(`${config.apiUrl}/TruckingRates/ReadListByCode?areaCode=${area}&chargeCode=${charge}&branchCode=${branch}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/TruckingRates/ReadListByCode?chargeCode=${charge}&branchCode=${branch}`, requestOptions).then(handleResponse);
    }
}

function truckingGroupByChargeCode() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/TruckingRates/truckingGroupByChargeCode`, requestOptions).then(handleResponse);
}

function truckingReadGroupCharge(charge, skip, take, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/TruckingRates/truckingReadGroupCharge?chargeCode=${charge}&skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/TruckingRates/truckingReadGroupCharge?chargeCode=${charge}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}

function truckingReadGroupBranchCharge(charge, branch, skip, take, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (search) {
        return fetch(`${config.apiUrl}/TruckingRates/truckingReadGroupBranchCharge?chargeCode=${charge}&branchCode=${branch}&skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    }
    else {
        return fetch(`${config.apiUrl}/TruckingRates/truckingReadGroupBranchCharge?chargeCode=${charge}&branchCode=${branch}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}